import { useEffect, useState } from "react";
import { useLocation, useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import "../css/Report.css";
axios.defaults.xsrfHeaderName = "X-CSRFTOKEN";
axios.defaults.xsrfCookieName = "csrftoken";

function Report() {
	const { reportId } = useParams();
	const [report, setReport] = useState(null);
	const [otherReports, setOtherReports] = useState(null);
	const { state } = useLocation();
	const navigate = useNavigate();

	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	useEffect(() => {
		if (state === null) {
			axios({
				url: "/evidence-map/data",
			})
				.then((response) => {
					response.data[reportId]["year"] =
						response.data[reportId]["year_of_publication"];
					delete response.data[reportId]["year_of_publication"];
					setReport(response.data[reportId]);
				})
				.catch((error) => {
					if (error.response) {
						console.log(error.response);
						console.log(error.response.status);
						console.log(error.response.headers);
					}
				});
		} else {
			setReport(state.reportData);
			// Find the index of the reportData object in the otherReports array
			const indexToRemove = state.otherReports.findIndex(
				(report) => report.index === state.reportData.index
			);

			if (indexToRemove !== -1) {
				// Remove the reportData object from the state.otherReports array
				state.otherReports.splice(indexToRemove, 1);
			}
			setOtherReports(state.otherReports);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	useEffect(() => {
		document.body.classList.remove("modal-open");
	}, []);

	return (
		<>
			<div id="report">
				<div className="row mt-0">
					{report && (
						<div
							id="reports_info"
							className={
								otherReports ? " col-12 col-lg-9" : " col-12"
							}
						>
							<h3
								className="reports-report-title"
								style={{ color: "black !important" }}
							>
								{report.title + " (" + report.year + ")"}
							</h3>
							<p className="reports-citation mt-3">
								{report.authors + " - "}
								<a
									href={report.source}
									id="report-link"
									target="_blank"
									rel="noreferrer"
								>
									View report here
								</a>
							</p>
							{/* Reports - abstract */}
							<h5 className="reports-abstract-label">Abstract</h5>
							<p>{report.abstract}</p>

							<button
								id="back_to_map_button"
								style={{ marginBottom: 58, width: 200 }}
								onClick={() => navigate("/evidence-map")}
							>
								Back
							</button>
						</div>
					)}
					{otherReports && (
						<div
							id="reports_sidebar"
							className="col-12 col-lg-3 mt-4 mt-lg-0"
						>
							{/* Reports - Other reports sidebar title */}
							<h3 className="similar-reports-label">
								{"Other reports in this category (" +
									otherReports.length +
									")"}
							</h3>
							<hr id="divider" />
							<ul className="similar-reports-list col-12 overflow-auto">
								{otherReports.map((otherReport) => (
									<div key={otherReport.index}>
										<a
											href={
												"/evidence-map/report/" +
												otherReport.index
											}
											id={otherReport.index}
											state={{
												reportData: report,
												otherReports: otherReports,
											}}
											className="report-links"
										>
											<li>
												{otherReport.title +
													" - " +
													otherReport.authors +
													" (" +
													otherReport.year +
													")"}
											</li>
										</a>
										<hr id="divider" />
									</div>
								))}
							</ul>
						</div>
					)}
				</div>
			</div>
		</>
	);
}

export default Report;
